module.exports = __webpack_public_path__ + "static/slide-1-135f9e63ac7ca1368eedaa8a52d0dc73.jpg";